module.exports = __webpack_public_path__ + "resources/img/logo_toast.59822f1c3e3506930a6130084bf84d1a.svg";